import { Inputs, useEffect } from "preact/hooks";

export const useInterval = (
  callback: () => void,
  interval: number,
  deps?: Inputs,
  fireOnStart?: boolean,
) => {
  useEffect(() => {
    if (fireOnStart) {
      callback();
    }
    const intervalID = setInterval(callback, interval);
    return () => clearInterval(intervalID);
  }, deps || []);
};
